export default "__VITE_ASSET__OGDAeB0I__"